import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;
    }

    @media screen and (min-width: ${theme.breakpoints[2]}) {
        .form__radio-button {
            margin-top: 16px;
        }
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        form {
            display: initial;
            height: initial;
        }
    }

    .form__radio {
        padding-bottom: 20px;
        margin-bottom: 20px;
        width: 100%;
        border: 0;
        border-bottom: 1px solid #e4e5e7;
    }

    .form__radio:last-child {
        border-bottom: 0;
    }

    button[type='submit'] {
        width: 100%;
    }
`

export const Content = styled.div`
    text-align: center;
    margin-bottom: 52px;

    & > p:first-child {
        margin-bottom: 12px;
    }
`
